
// JS
import 'bootstrap';


import './js/vendor/modernizr-custom';

import './js/blocks/accordion';
import './js/blocks/tabs';
import './js/app/citycycling';
import './js/main';


// CSS
import './scss/main.scss';
